const state = () => ({
    user: null,
})
const mutations = {
    SET_USER(state, payload) {
        state.user = payload
    }
}

const getters = {
    IS_AUTH: state => {
        return state.user != null
    },
    GET_USER: state => state.user
}

const actions = {
    
}

export default {
    state,
    mutations,
    actions,
    namespaced: true,
    getters
}